import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import {
  createNewPartner,
  deletePartnerFile,
  getPartnerByID,
  getPartnerFile,
  updatePartner,
  uploadPartnerFile,
} from "../../../API/endpoints/Partner";
import { partnerDataDTO } from "../../dtos/partner.dtos";

import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ToastMessage from "../toasts/ToastMessage";
import { Item } from "react-bootstrap/lib/Breadcrumb";

function PartnerInfoForm(props: {
  setPartnerID: (arg0: any) => void;
  setDefaultTab: (arg0: string) => void;
  countries: any[];
  years: any[];
  handleNotification: (type: string, msg: string) => void;
  categories: any[];
  permissions: any;
  userName?: string | undefined;
  userID?: string | undefined;
  onContinue: (tab: string, status: boolean, data?: any, frmData?: any) => void;
  data: any | {};
}) {
  const params = useParams();
  const navigate = useNavigate();
  const [partnerDetails, setPartnerDetails] = useState<partnerDataDTO>();
  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [files, setFiles] = useState<string[]>([]);
  const [partnerDocs, setPartnerDocs] = useState<any[]>([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      created_by: props?.userName,
      partner_name: "",
      country_of_origin: "",
      website: "",
      company_overview: null,
      client_portfolio: null,
      draft_agreement: null,
    },
  });

  useEffect(() => {
    let defaults = {
      created_by: props.userName,
    };
    reset(defaults);
  }, [props.userName]);

  useEffect(() => {
    if (props.data) {
      const defaults = {
        created_by: props?.data?.created_by,
        partner_name: props?.data?.partner_name,
        country_of_origin: props?.data?.country_of_origin,
        website: props?.data?.website,
      };
      reset(defaults);
    }
  }, [props.data, reset]);

  useEffect(() => {
    if (params?.partnerid) {
      (async () => {
        let data = await getPartnerByID(params?.partnerid);
        let documents = await getPartnerFile(params?.partnerid);
        setPartnerDocs(documents?.data || []);
        setFiles(documents?.data?.map((doc: any) => doc.file_name));
        data = {
          ...data.data,
          // purchase_inventory: data.data.purchase_inventory.toString(),
        };
        setPartnerDetails(data);
        // if (data?.partner_categories?.length !== 0) {
        //   setDefaultCategories(
        //     data?.partner_categories.map((itm: any) => {
        //       return {
        //         id: itm.focus_category,
        //         name: itm.categories.name,
        //       };
        //     })
        //   );

        //   setSelectedCategories(
        //     data?.partner_categories.map((itm: any) => itm.focus_category)
        //   );
        // }
        // if (data?.partner_categories?.length !== 0) {
        //   setDefaultCategories(
        //     data?.partner_categories.map((itm: any) => {
        //       return {
        //         id: itm.focus_category,
        //         name: itm.categories.name,
        //       };
        //     })
        //   );

        //   setSelectedCategories(
        //     data?.partner_categories.map((itm: any) => itm.focus_category)
        //   );
        // }
      })();
    }
  }, [params?.partnerid]);

  useEffect(() => {
    if (partnerDetails) {
      let defaults = {
        created_by: props.userName,
        partner_name: partnerDetails ? partnerDetails.name : "",
        country_of_origin: partnerDetails?.region?.id,
        website: partnerDetails ? partnerDetails.website : "",
      };
      reset(defaults);
    }
  }, [props.userName, partnerDetails, reset]);

  const onSubmit = (data: any) => {

    let frmData: any = {
      created_by: props?.userID,
      name: data?.partner_name,
      country_of_origin: data?.country_of_origin,
      website: data?.website?.trim(),
    };
    if (params?.partnerid) {
      updatePartner(frmData, params?.partnerid)
        .then(async (res) => {
          const overviewData = new FormData();
          if (data.company_overview) {
            overviewData.append("file", data.company_overview[0]);
            overviewData.append("file_name", "Company Overview");
            overviewData.append(
              "partner_id",
              params.partnerid ? params.partnerid : ""
            );
            overviewData.append("service", "1");
            const overviewUpload = await uploadPartnerFile(overviewData);
          }

          if (data.client_portfolio) {
            const portfolioData = new FormData();
            portfolioData.append("file", data.client_portfolio[0]);
            portfolioData.append("file_name", "Client Portfolio");
            portfolioData.append(
              "partner_id",
              params.partnerid ? params.partnerid : ""
            );
            portfolioData.append("service", "1");
            const portfolioUpload = await uploadPartnerFile(portfolioData);
          }

          if (data.draft_agreement) {
            const agreementData = new FormData();
            agreementData.append("file", data.draft_agreement[0]);
            agreementData.append("file_name", "Draft Agreement");
            agreementData.append(
              "partner_id",
              params.partnerid ? params.partnerid : ""
            );
            agreementData.append("service", "1");
            const agreementUpload = await uploadPartnerFile(agreementData);
          }

          setNotification({
            type: "success",
            msg: "Updated successfully",
          });
          navigate(-1);
        })
        .catch((err) => {
          console.log("update error", err);
          setNotification({
            type: "error",
            msg: "Update failed !",
          });
        });
    } else {
      const overviewData = new FormData();
      overviewData.append("file", data.company_overview[0]);
      overviewData.append("file_name", "Company Overview");
      // overviewData.append("partner_id", res.data.id);
      overviewData.append("service", "1");

      const portfolioData = new FormData();
      portfolioData.append("file", data.client_portfolio[0]);
      portfolioData.append("file_name", "Client Portfolio");
      // portfolioData.append("partner_id", res.data.id);
      portfolioData.append("service", "1");

      const agreementData = new FormData();
      agreementData.append("file", data.draft_agreement[0]);
      agreementData.append("file_name", "Draft Agreement");
      // agreementData.append("partner_id", res.data.id);
      agreementData.append("service", "1");

      props.onContinue("overview", true, frmData, {
        overViewData: overviewData,
        portfolioData: portfolioData,
        agreementData: agreementData,
      });

      // createNewPartner(frmData)
      //   .then(async (res) => {
      //     console.log("res", res);
      //     console.log("res?.data?.id", res?.data?.id);

      //     if (res?.data?.id) {
      //       const overviewData = new FormData();
      //       overviewData.append("file", data.company_overview[0]);
      //       overviewData.append("file_name", "Company Overview");
      //       overviewData.append("partner_id", res.data.id);
      //       overviewData.append("service", "1");

      //       const portfolioData = new FormData();
      //       portfolioData.append("file", data.client_portfolio[0]);
      //       portfolioData.append("file_name", "Client Portfolio");
      //       portfolioData.append("partner_id", res.data.id);
      //       portfolioData.append("service", "1");

      //       const agreementData = new FormData();
      //       agreementData.append("file", data.draft_agreement[0]);
      //       agreementData.append("file_name", "Draft Agreement");
      //       agreementData.append("partner_id", res.data.id);
      //       agreementData.append("service", "1");

      //       const overviewUpload = await uploadPartnerFile(overviewData);
      //       const portfolioUpload = await uploadPartnerFile(portfolioData);
      //       const agreementUpload = await uploadPartnerFile(agreementData);

      //       if (
      //         overviewUpload.msg === "Documents uploaded successfully" ||
      //         portfolioUpload.msg === "Documents uploaded successfully" ||
      //         agreementUpload.msg === "Documents uploaded successfully"
      //       ) {
      //         props.onContinue("overview", true, frmData);
      //       }
      //     }
      //   })
      //   .catch((err) => console.log("err", err));
    }

    // props.onContinue("overview", true, frmData, formData);

    // let newData: any = {
    //   company_name: data.company_name,
    //   company_address_line1: data.company_address_line1,
    //   company_registration_number: data.company_registration_number,
    //   website: data.website,
    //   country_of_origin: data.country_of_origin,
    //   purchase_inventory: data.purchase_inventory,
    //   // focus_categories: [+data?.focus_categories],
    //   focus_categories: selectedCategories,
    //   // focus_categories: [+data?.focus_categories],
    //   partner_type: +data?.partner_type,
    // };
    // if (data.company_address_line2)
    //   newData.company_address_line2 = data.company_address_line2;
    // if (data.company_address_postal_code)
    //   newData.company_address_postal_code = data.company_address_postal_code;
    // if (data.years_of_experience)
    //   newData.years_of_experience = data.years_of_experience;
    // if (data.no_of_cus) newData.no_of_cus = data.no_of_cus;
    // if (data.revenue_of_cus) newData.revenue_of_cus = data.revenue_of_cus;
    // if (selectedCategories.length === 0) {
    //   setCategoryMessage("* This field is required");
    //   return;
    // }
    // if (selectedCategories.length === 0) {
    //   setCategoryMessage("* This field is required");
    //   return;
    // }
    // if (partnerDetails) {
    //   (async () => {
    //     const res = await UpdatePartner(newData, params.partnerid);
    //     console.log(res);
    //     const activity = await CreateActivity(
    //       `Partner ${data.company_name} updated.`
    //     );
    //     console.log(activity);
    //     props.handleNotification("success", "Updated successfully");
    //     setCategoryMessage("");
    //     setCategoryMessage("");
    //   })();
    // } else {
    //   (async () => {
    //     console.log(newData);
    //     const res = await CreatePartner(newData);
    //     console.log(res);
    //     const activity = await CreateActivity(
    //       `Partner ${data.company_name} added.`
    //     );
    //     console.log(activity);
    //     props.setPartnerID(res.data.id);
    //     if (
    //       props?.permissions[0]?.sub_modules[1]?.permissions_actions[1]
    //         ?.permission[0]?.permission
    //     ) {
    //       props.setDefaultTab("partner-team");
    //     } else if (
    //       props?.permissions[0]?.sub_modules[2]?.permissions_actions[1]
    //         ?.permission[0]?.permission
    //     ) {
    //       props.setDefaultTab("partner-service-capabilities");
    //     } else {
    //       navigate("/PartnerManagement");
    //     }
    //     setCategoryMessage("");
    //     setCategoryMessage("");
    //   })();
    // }
  };

  const handleCloseNotification = () =>
    setNotification({
      type: "",
      msg: "",
    });

  const onChangeClick = (field: string) => {
    const docs = [...files];
    let index = docs.indexOf(field);

    if (index > -1) {
      const deletedFileId = partnerDocs.find((item: any) => item?.file_name === field)?.id;
      deleteDocumentHandler(deletedFileId);
      docs.splice(index, 1);
      setFiles([...docs]);
    }
  };

  const deleteDocumentHandler = (id: any) => {
    (async () => {
      try {
        const response = await deletePartnerFile(id);
      } catch (error) { }
    })();
  };

  return (
    <Form
      onSubmit={handleSubmit((data) => {
        onSubmit(data);
      })}
      className="mt40px"
    >
      <Container fluid>
        <Row>
          <Col sm={6} md={4} lg={3} className="p-0">
            <Form.Group
              className="formgroup mr12px"
              controlId="formOrganizationName"
            >
              <Form.Label>Created By</Form.Label>
              <Form.Control
                type="text"
                placeholder="Auto Selected Based on the Login"
                {...register("created_by")}
                disabled
              />
              <Form.Text muted>
                <span>
                  <p className="error-form">{errors.created_by?.message}</p>
                </span>
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={3} className="p-0">
            <Form.Group className="formgroup" controlId="formBusinessRegNo">
              <Form.Label>Partner Name </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Partner name"
                {...register("partner_name", {
                  required: "* This field is required",
                  pattern: {
                    value: /^(?=.*[a-zA-Z])[\w\d\s!@#$%^&*()-_=+`~[\]{}|;:'",<.>/?\\]*$/,
                    message: 'Only special characters or numbers are not allowed'
                  }
                })}
              />
              <Form.Text muted>
                <span>
                  <p className="error-form">{errors.partner_name?.message}</p>
                </span>
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt24px">
          <Col sm={6} md={4} lg={3} className="p-0">
            <Form.Group
              className="formgroup mr12px"
              controlId="formCountryOfOrigin"
              key={"country" + Math.floor(Math.random() * 100)}
            >
              <Form.Label>Country of origin *</Form.Label>
              <Form.Select
                {...register("country_of_origin", {
                  required: "* This field is required",
                })}
              >
                {props.countries?.map(
                  (country: { id: string; name: string }) => {
                    return (
                      <option value={country.id} key={country.id}>
                        {country.name}
                      </option>
                    );
                  }
                )}
              </Form.Select>
              <Form.Text muted>
                <span>
                  <p className="error-form">
                    {errors.country_of_origin?.message}
                  </p>
                </span>
              </Form.Text>
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={3} className="p-0">
            <Form.Group className="formgroup" controlId="formOrgWebsite">
              <Form.Label>Organization's Website</Form.Label>
              <InputGroup>
                <InputGroup.Text id="http-addon">https://</InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Enter Organization Website"
                  {...register("website", {
                    required: "* This field is required",
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/,
                      message: "Invalid website",
                    },
                  })}
                />
              </InputGroup>
              <Form.Text muted>
                <span>
                  <p className="error-form">{errors?.website?.message}</p>
                </span>
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt24px">
          <Col sm={12} md={6} lg={6} className="p-0 customtable">
            <TableContainer
              component={Paper}
              sx={{ boxShadow: "none", borderColor: "#344054" }}
            >
              <Table aria-label="simple table">
                <TableHead
                  sx={{ background: "#fcfcfd", borderColor: "#344054" }}
                >
                  <TableRow>
                    <TableCell align="left" sx={{ minWidth: "300px" }}>
                      File
                    </TableCell>
                    <TableCell>Upload</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell align="left">Company Overview</TableCell>
                    <TableCell align="left">
                      <FormControl variant="standard">
                        {params?.partnerid &&
                          files.includes("Company Overview") ? (
                          <Input
                            className="inputfile"
                            id="input-with-icon-adornment"
                            value={"Company Overview"}
                            disabled
                            startAdornment={
                              <InputAdornment position="start">
                                <img
                                  src="../svgs/upload_icon.svg"
                                  alt="upload_icon"
                                />
                              </InputAdornment>
                            }
                            endAdornment={
                              <Button
                                size="sm"
                                variant="link"
                                style={{ textDecoration: "none" }}
                                onClick={() =>
                                  onChangeClick("Company Overview")
                                }
                              >
                                Change
                              </Button>
                            }
                          />
                        ) : (
                          <Input
                            className="inputfile"
                            type="file"
                            id="input-with-icon-adornment"
                            inputProps={{ accept: 'application/pdf' }}
                            {...register(
                              "company_overview",
                              params.partnerid
                                ? { required: !files.includes("Company Overview") ? "* This field is required" : '' }
                                : {
                                  required: "* This field is required",
                                }
                            )}
                            startAdornment={
                              <InputAdornment position="start">
                                <img
                                  src="../svgs/upload_icon.svg"
                                  alt="upload_icon"
                                />
                              </InputAdornment>
                            }
                          />
                        )}

                        <Form.Text muted>
                          <span>
                            <p className="error-form">
                              {errors.company_overview?.message}
                            </p>
                          </span>
                        </Form.Text>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">Client Portfolio</TableCell>
                    <TableCell align="left">
                      <FormControl variant="standard">
                        {params?.partnerid &&
                          files.includes("Client Portfolio") ? (
                          <Input
                            className="inputfile"
                            id="input-with-icon-adornment"
                            value={"Client Portfolio"}
                            disabled
                            startAdornment={
                              <InputAdornment position="start">
                                <img
                                  src="../svgs/upload_icon.svg"
                                  alt="upload_icon"
                                />
                              </InputAdornment>
                            }
                            endAdornment={
                              <Button
                                size="sm"
                                variant="link"
                                style={{ textDecoration: "none" }}
                                onClick={() =>
                                  onChangeClick("Client Portfolio")
                                }
                              >
                                Change
                              </Button>
                            }
                          />
                        ) : (
                          <Input
                            className="inputfile"
                            type="file"
                            id="input-with-icon-adornment"
                            inputProps={{ accept: 'application/pdf' }}
                            {...register(
                              "client_portfolio",
                              params.partnerid
                                ? { required: !files.includes("Client Portfolio") ? "* This field is required" : '' }
                                : {
                                  required: "* This field is required",
                                }
                            )}
                            startAdornment={
                              <InputAdornment position="start">
                                <img
                                  src="../svgs/upload_icon.svg"
                                  alt="upload_icon"
                                />
                              </InputAdornment>
                            }
                          />
                        )}
                        <Form.Text muted>
                          <span>
                            <p className="error-form">
                              {errors.client_portfolio?.message}
                            </p>
                          </span>
                        </Form.Text>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">Draft Agreement</TableCell>
                    <TableCell align="left">
                      <FormControl variant="standard">
                        {params?.partnerid &&
                          files.includes("Draft Agreement") ? (
                          <Input
                            className="inputfile"
                            id="input-with-icon-adornment"
                            value={"Draft Agreement"}
                            disabled
                            startAdornment={
                              <InputAdornment position="start">
                                <img
                                  src="../svgs/upload_icon.svg"
                                  alt="upload_icon"
                                />
                              </InputAdornment>
                            }
                            endAdornment={
                              <Button
                                size="sm"
                                variant="link"
                                style={{ textDecoration: "none" }}
                                onClick={() => onChangeClick("Draft Agreement")}
                              >
                                Change
                              </Button>
                            }
                          />
                        ) : (
                          <Input
                            className="inputfile"
                            type="file"
                            id="input-with-icon-adornment"
                            inputProps={{ accept: 'application/pdf' }}
                            {...register(
                              "draft_agreement",
                              params.partnerid
                                ? { required: !files.includes("Draft Agreement") ? "* This field is required" : '' }
                                : {
                                  required: "* This field is required",
                                }
                            )}
                            startAdornment={
                              <InputAdornment position="start">
                                <img
                                  src="../svgs/upload_icon.svg"
                                  alt="upload_icon"
                                />
                              </InputAdornment>
                            }
                          />
                        )}
                        <Form.Text muted>
                          <span>
                            <p className="error-form">
                              {errors.draft_agreement?.message}
                            </p>
                          </span>
                        </Form.Text>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Col>
        </Row>
      </Container>
      <Container fluid className="bt-gray200 mt40px">
        <Row className="justify-content-end mb-3 mt-4">
          <Col className="d-flex justify-content-end">
            <Link to="/PartnerManagement" className="m-1">
              <Button variant="secondary" className="btn-secondary12">
                Cancel
              </Button>
            </Link>

            {props?.permissions[0]?.sub_modules[0]?.permissions_actions[2]
              ?.permission[0]?.permission &&
              params.partnerid && (
                <Button
                  variant="primary"
                  className="btn-primary12 m-1"
                  type="submit"
                >
                  Update
                </Button>
              )}
            {props?.permissions[0]?.sub_modules[0]?.permissions_actions[0]
              ?.permission[0]?.permission &&
              !params.partnerid && (
                <Button
                  variant="primary"
                  className="btn-primary12 m-1"
                  type="submit"
                >
                  Save and continue
                </Button>
              )}
          </Col>
        </Row>
      </Container>
      <ToastMessage
        notification={notification}
        onCancel={handleCloseNotification}
      />
    </Form>
  );
}

export default PartnerInfoForm;
